// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__ka_E2","header":"ClearentDisclaimer_header__3anCq","inner":"ClearentDisclaimer_inner__1hk0U"};